import { UUID_regex } from "Utils/General/KeyGenerator";
import { AddSchema } from "mobx-firelink";
export class BookEvent {
    constructor(initialData) {
        this.Extend(initialData);
    }
}
AddSchema("BookEvent", {
    properties: {
        book: { $ref: "UUID" },
        characters: { $ref: "CharacterSet" },
        week: { type: ["null", "number"] },
        day: { type: ["null", "number"] },
        //time: {type: ["null", "string"]},
        seed: { type: ["null", "string"] },
        text: { type: "string" },
        placeholderCount: { type: ["null", "number"] },
        steps: { items: { $ref: "BookEventStep" } },
        fullText: { type: "string" },
    },
});
AddSchema("CharacterSet", { patternProperties: { [UUID_regex]: { $ref: "CharacterEntry" } } });
AddSchema("CharacterEntry", {
    properties: {
        _: { type: "boolean" },
        main: { type: ["null", "boolean"] },
    },
    required: ["_"],
});
export class BookEventStep {
    constructor() {
        this.actions = {};
    }
}
AddSchema("BookEventStep", {
    properties: {
        actions: { $ref: "CharacterActionSet" },
    },
});
AddSchema("CharacterActionSet", { patternProperties: { [UUID_regex]: { type: "string" } } });
